// components/dnd/subtasks/subtasks.component.jsx
import React, { useState, useMemo, useEffect } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { updateSubDrag } from "../../../firebase/firebase.utils.js";
import { AnimatePresence } from "framer-motion";

import RetroLabel from "../../retro/retro-label/retro-label.component";
import Subtask from "./subtask/subtask.component";
import AddSubtask from "./add-subtask/add-subtask.component";

import "./subtasks.styles.scss";

import { FaCheckDouble } from "react-icons/fa";
import { BsChevronRight, BsChevronDown } from "react-icons/bs";

const Subtasks = ({ task, open, length, opacity }) => {
  const [state, setState] = useState([]);
  const [nrOfCompleted, setNrOfCompleted] = useState(0);
  const [newSubtask, setNewSubtask] = useState("");
  const [subtasksOpen, setSubtasksOpen] = useState(true);
  const [subtaskView, setSubtaskView] = useState(false);
  // const { fromSpaceId, fromStationId, id, subtasks, done } = task;

  useMemo(() => {
    setState(task.subtasks);
  }, [task]);

  useEffect(() => {
    if (open) {
      setSubtasksOpen(true);
    } else if (open === false) {
      setSubtasksOpen(false);
    }
  }, [open]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    if (!destination) return;

    if (result.type === "subtasksType") {
      if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
      ) {
        return;
      }

      const start = source.index;
      const finish = destination.index;

      const newData = reorder(state, start, finish);
      setState(newData);
      updateSubDrag(task?.fromSpaceId, task?.fromStationId, task?.id, newData);
    }
  };
  const onDragStart = () => {};

  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <Droppable droppableId={"subtasks"} type="subtasksType">
        {(provided) => {
          return (
            <div
              className="subtasks"
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                opacity: task?.done && 0.2,
                pointerEvents: task?.done && "none",
              }}
            >
              {state?.length > 0 ? (
                <div className="subtasks__task">
                  <div
                    className="subtasks__label"
                    onClick={() => setSubtasksOpen(!subtasksOpen)}
                  >
                    <i className="subtasks__label-connect"></i>
                    <RetroLabel>
                      {subtasksOpen ? (
                        <>
                          {state.length} subtasks <BsChevronDown />
                        </>
                      ) : (
                        <>
                          {state.length} subtasks <BsChevronRight />
                        </>
                      )}
                    </RetroLabel>
                  </div>
                  <AnimatePresence>
                    {subtasksOpen && (
                      <>
                        {state.map((item, index) => {
                          return (
                            <Subtask
                              parentTask={task}
                              task={item}
                              index={index}
                              key={item}
                              setNrOfCompleted={setNrOfCompleted}
                            />
                          );
                        })}

                        {provided.placeholder}
                        <AddSubtask
                          task={task}
                          setSubtasksOpen={setSubtasksOpen}
                          inputText="Add Subtask"
                        />
                      </>
                    )}
                  </AnimatePresence>
                </div>
              ) : (
                <div
                  className={`subtask__label-gray ${opacity}`}
                  style={{ opacity: subtaskView ? 1 : 0 }}
                >
                  <div
                    className="subtask__addFalse"
                    onClick={() => setSubtaskView(!subtaskView)}
                  >
                    <i className="subtasks__label-connect"></i>
                    <RetroLabel color="gray">
                      Add subtask <FaCheckDouble />
                    </RetroLabel>
                  </div>
                  {subtaskView && (
                    <AddSubtask task={task} setSubtasksOpen={setSubtasksOpen} />
                  )}
                </div>
              )}
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
};

export default Subtasks;
